export const POSTCODE_SEARCH_PARAM = 'postcode'
export const COUNTRY_CODE_SEARCH_PARAM = 'country_code'
export const DISTANCE_SEARCH_PARAM = 'distance'
